import wireframeMapMenuIcon from '../assets/icons/wireframeMapMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframeMap extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style = 'map';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeMapMenuIcon;
  }

  static externalName(): string {
    return 'Map';
  }
}

export default WireframeMap;
